// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1zyoS","title":"BackImages_title__3NQla","images":"BackImages_images__3grsV"};